function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null);

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  id: "icon-148-tag-add"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,21 L9,18 L10,18 L10,21 L13,21 L13,22 L10,22 L10,25 L9,25 L9,22 L6,22 L6,21 L9,21 L9,21 Z M6.01331559,16.0133156 L4,14 L4,5.99961498 C4,4.88743329 4.89525812,4 5.99961498,4 L14,4 L27.3809027,17.3809027 C28.1640508,18.1640508 28.168017,19.4319586 27.3884415,20.2115341 L20.2115341,27.3884415 C19.433119,28.1668566 18.1646418,28.1646418 17.3809027,27.3809027 L14.9866844,24.9866844 C15.6282885,23.9791534 16,22.7829857 16,21.5 C16,17.9101489 13.0898511,15 9.5,15 C8.21701435,15 7.02084661,15.3717115 6.01331559,16.0133156 L6.01331559,16.0133156 L6.01331559,16.0133156 Z M9.5,11 C10.3284272,11 11,10.3284272 11,9.5 C11,8.67157283 10.3284272,8 9.5,8 C8.67157283,8 8,8.67157283 8,9.5 C8,10.3284272 8.67157283,11 9.5,11 L9.5,11 Z M9.5,27 C12.5375663,27 15,24.5375663 15,21.5 C15,18.4624337 12.5375663,16 9.5,16 C6.46243373,16 4,18.4624337 4,21.5 C4,24.5375663 6.46243373,27 9.5,27 L9.5,27 Z",
  id: "tag-add"
})));

var SvgAddTag = function SvgAddTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "32px",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlnssketch: "http://www.bohemiancoding.com/sketch/ns",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Add_Tag.63809784.svg";
export { ForwardRef as ReactComponent };